import { Instant } from '@js-joda/core';
import { getJson, postJson, putJson, withMap, withDone, withOptional, withValidate } from '@rad/utility/http';
const mapEvent = (x) => (Object.assign(Object.assign({}, x), { 'startsAt': Instant.parse(x.startsAt), 'endsAt': x.endsAt ? Instant.parse(x.endsAt) : null }));
export const getEvents = (filters) => withMap(getJson(`/api/events`, filters), (xs) => xs.map(mapEvent));
export const getEvent = (id) => withOptional(withMap(getJson(`/api/events/${id}`), mapEvent));
export const getEventTypes = () => getJson(`/api/events/types`);
export const getEventStatuses = () => getJson(`/api/events/statuses`);
export const createEvent = (e) => withDone(withValidate(postJson(`/api/events`, e)))();
export const updateEvent = (e) => withDone(withValidate(putJson(`/api/events`, e)))();
export const deleteEvent = (id) => withDone(withOptional(postJson(`/api/events/delete/${id}`)))();
